import React, { Component } from 'react'
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import { connect } from 'react-redux';
import { createUser, verifyUser } from './Cognito'

class Signup extends Component {
  constructor (props) {
    super(props)
    this.changeEmail = this.changeEmail.bind(this)
    this.changeName = this.changeName.bind(this)
    this.changeFamilyName = this.changeFamilyName.bind(this)
    this.changeUsername = this.changeUsername.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changeVerifyCode = this.changeVerifyCode.bind(this)
    this.handleSignupSubmit = this.handleSignupSubmit.bind(this)
    this.handleVerifySubmit = this.handleVerifySubmit.bind(this)

    this.state = {
      email: '',
      password: '',
      verifyCode: '',
			name: '',
			family_name: '',
      username: '',
      showVerification: false,
			error: ''
    }
  }

  changeEmail (e) {
    this.setState({ email: e.target.value.toLowerCase() })
  }

  changeName (e) {
    this.setState({ name: e.target.value })
  }

  changeFamilyName (e) {
    this.setState({ family_name: e.target.value })
  }

  changeUsername (e) {
    this.setState({ username: e.target.value })
  }

  changePassword (e) {
    this.setState({ password: e.target.value })
  }

  changeVerifyCode (e) {
    this.setState({ verifyCode: e.target.value })
  }

	setError (e) {
		this.setState({ error: e})
	}

  handleSignupSubmit (e) {
    const { username, email, password, name, family_name } = this.state
    e.preventDefault()
    createUser(username, password, email, name, family_name, (err, result) => {
      if (err) {
        console.log(err)
				this.setError(err)
        return
      }
      //console.log(result.user)
      this.setState({ showVerification: true })
    })
  }

  handleVerifySubmit (e) {
    e.preventDefault()
    verifyUser(this.state.username, this.state.verifyCode, (err, result) => {
      if (err) {
        console.log(err)
        return
      }
      alert(result)
    })
  }

  render () {
	const style = {
		'float': 'left',
		width: '48%',
		height: '100%',
	  margin: 10,
		padding: 10,
	  textAlign: 'center',
	  display: 'inline-block',
	};
		const { authentication } = this.props;
    return (
			<div>{ authentication && !authentication.loggedIn &&
				<Paper zDepth={2} style={style} className="Signup">
      	  <h2>Sign Up</h2>
      	  {
      	    !this.state.showVerification ? (
      	      <form onSubmit={this.handleSignupSubmit}>
								<div>
      	          <TextField
      	            value={this.state.email}
      	            hintText='Email'
      	            type='email'
      	            onChange={this.changeEmail} />
								</div>
								<div>
      	          <TextField
      	            value={this.state.name}
      	            hintText='First Name'
      	            onChange={this.changeName} />
								</div>
								<div>
      	          <TextField
      	            value={this.state.family_name}
      	            hintText='Last Name'
      	            onChange={this.changeFamilyName} />
								</div>
								<div>
      	          <TextField
      	            value={this.state.username}
      	            hintText='Username'
      	            onChange={this.changeUsername} />
								</div>
								<div>
      	          <TextField
      	            value={this.state.password}
      	            hintText='Password'
      	            type='password'
      	            minLength={8}
      	            onChange={this.changePassword} />
									{ this.error &&
										<p>{this.state.error.message}</p>
									}
								</div>
								<div>
      	          <RaisedButton type='submit'>Sign up</RaisedButton>
								</div>
      	      </form>
						) : (
          	  <form onSubmit={this.handleVerifySubmit}>
								<div>
          	    <TextField
          	      value={this.state.verifyCode}
          	      onChange={this.changeVerifyCode}
          	      hintText='code' />
								</div >
								<div>
          	    <RaisedButton type='submit'>Verify</RaisedButton>
								</div>
          	  </form>
          	)
        }
		</Paper>}</div>
    )
  }
}

function mapStateToProps(state) {
    const { registering } = state.registration;
		const { authentication } = state;
		return {
			authentication,
			registering
		};
}

const connectedSignup = connect(mapStateToProps)(Signup);
export default connectedSignup



// WEBPACK FOOTER //
// ./src/Signup.jsx